// extracted by mini-css-extract-plugin
export default {"currentHint":"currentHint---OS3tt"};